import { supabase } from '@/integrations/supabase/client';

/**
 * A busca que tenta tudo, a mesma da página Leads e da Carteira (Douglas 04/11/2026).
 *
 * Acha o lead pelo telefone com DDD, com 55 na frente ou sem o 9, pelos 8
 * telefones do lead, pelo telefone e nome dos sócios, CPF, número do lead e
 * nome — pelos índices do banco, em menos de 0,2 s. Antes cada tela tinha a
 * sua: ILIKE em 2 a 8 colunas, varrendo ~1 milhão de leads, e o celular do
 * sócio da VITANA não aparecia em lugar nenhum.
 *
 * `null` = a busca não tem caminho rápido (curta ou larga demais): a tela
 * segue com a busca que já tinha. `[]` = procurou e não achou.
 */

type Rpc = (fn: string, args: Record<string, unknown>) => Promise<{ data: unknown; error: unknown }>;
const rpc = supabase.rpc.bind(supabase) as unknown as Rpc;

async function chamar(fn: string, busca: string, max: number): Promise<string[] | null> {
  const termo = String(busca || '').trim();
  if (!termo) return null;
  try {
    const { data, error } = await rpc(fn, { p_busca: termo, p_max: max });
    if (error || !Array.isArray(data)) return null;
    return (data as unknown[]).map(String);
  } catch {
    return null;
  }
}

export function leadsDaBusca(busca: string, max = 200): Promise<string[] | null> {
  return chamar('fn_busca_leads_ids_ate', busca, max);
}

export function cnpjsDaBusca(busca: string, max = 200): Promise<string[] | null> {
  return chamar('fn_busca_cnpjs_ate', busca, max);
}
